module.exports = __webpack_public_path__ + "static/media/ic-link.4f5db327.svg";